import { useCallback, useMemo } from "react";
import { getWidth } from "../utils/ui";
import { useContainerDimensions } from "./useContainerDimensions";
import { isMobile, isTablet } from "react-device-detect";
import { DefaultTheme } from "styled-components";
import { ROOT_ID } from "../utils/constants";

export const colors = {
  white: "#fff",
  grey1: "#6a768c",
  grey2: "#506b81",
  grey3: "#3b3b3b",
  grey4: "#f4f4f4",
  grey5: "#f6f7fa",
  grey6: "#fafafa",
  grey7: "#dee2e6",
  grey8: "#707070",
  grey9: "#e1e5ef",
  green1: "#518a70",
  green2: "#447355",
  green3: "#edf3f0",
  green4: "#EAF2E6",
  green5: "#6CB86A",
  green6: "#87A28E",
  black: "#3C4453",
};

export function useCustomTheme() {
  const containerDimensions = useContainerDimensions();
  const rootElement = document.getElementById(ROOT_ID);
  const isMobileCheck = isMobile && !isTablet;
  const isMobileFlag =
    rootElement?.dataset.preview === "mobile" || isMobileCheck;

  const getValue = useCallback(
    (value: number): number =>
      getWidth({
        containerDimensions,
        isMobile: isMobileFlag,
        value,
      }),
    [containerDimensions, isMobileFlag],
  );

  const theme = useMemo(
    (): DefaultTheme => ({
      container: containerDimensions,
      getValue,
      getFontSize: getValue,
      isMobile: isMobileFlag,
      colors,
    }),
    [containerDimensions, getValue, isMobileFlag],
  );

  return theme;
}
